<template>
    <div>
        <el-card>
            <div style="display: flex; justify-content: space-between; align-items: center">
                <div style="font-weight: 600">订单查看</div>
                <div style="display: flex; align-items: center">
                    <el-input v-model="searchKeyword" placeholder="搜索客户名称或订单ID" style="margin-right: 10px; width: 230px" clearable @keyup.enter.native="loadOrdersFromApi">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                    <el-select v-model="statusFilter" placeholder="选择订单状态" style="margin-right: 10px; width: 180px" @change="loadOrdersFromApi">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option label="待发货" value="待发货"></el-option>
                        <el-option label="待收货" value="待收货"></el-option>
                        <el-option label="申请取消" value="申请取消"></el-option>
                        <el-option label="订单取消" value="订单取消"></el-option>
                        <el-option label="订单完成" value="订单完成"></el-option>
                    </el-select>
                    <el-date-picker
                        v-model="dateRange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        style="margin-right: 10px; width: 350px"
                        value-format="yyyy-MM-dd"
                        @change="handleDateChange"
                    >
                    </el-date-picker>
                    <el-button @click="loadOrdersFromApi" type="primary" plain>刷新订单</el-button>
                    <el-switch v-model="soundEnabled" active-text="提示音" inactive-text="静音" style="margin-left: 8px"></el-switch>
                </div>
            </div>

            <!-- 订单汇总信息 -->
            <div style="margin: 16px 0; padding: 12px; background-color: #f5f7fa; border-radius: 4px">
                <div style="display: flex; justify-content: space-between; flex-wrap: wrap">
                    <div>
                        <span style="font-weight: bold">订单总数：</span>
                        <span>{{ summary.totalOrders }}</span>
                    </div>
                    <div>
                        <span style="font-weight: bold">总金额：</span>
                        <span style="color: #e6a23c">¥{{ summary.totalAmount.toFixed(2) }}</span>
                    </div>

                    <div>
                        <span style="font-weight: bold">已发货：</span>
                        <span>{{ summary.shippedOrders }}</span>
                    </div>
                    <div>
                        <span style="font-weight: bold">已完成：</span>
                        <span>{{ summary.completedOrders }}</span>
                    </div>
                    <div>
                        <span style="font-weight: bold">待审核退货：</span>
                        <span>{{ summary.pendingRefunds }}</span>
                    </div>
                </div>
            </div>

            <el-table :data="orders" style="width: 100%; margin-top: 16px" height="calc(100vh - 280px)" @row-dblclick="handleRowDblclick">
                <el-table-column prop="id" label="订单ID" min-width="80" />
                <el-table-column prop="userName" label="用户账号" min-width="120" />
                <el-table-column prop="user_name" label="用户名称" min-width="180" />
                <el-table-column prop="user_sale_name" label="销货负责人" min-width="120" />
                <el-table-column label="商品" min-width="90">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click.stop="openOrderDetail(scope.row)"> 商品详情 </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="totalAmount" label="金额(¥)" min-width="80" />
                <el-table-column prop="express_company" label="快递公司" min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.express_company || scope.row.expressCompany || '—' }}
                    </template>
                </el-table-column>
                <el-table-column prop="express_no" label="快递单号" min-width="150">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status === '待发货'" type="primary" size="mini" icon="el-icon-truck" @click.stop="markToReceivingWithLogistics(scope.row)"> 填写单号 </el-button>
                        <span v-else-if="scope.row.express_no">{{ scope.row.express_no }}</span>
                        <span v-else style="color: #909399">—</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" min-width="90">
                    <template slot-scope="scope">
                        <el-tag size="small">{{ scope.row.status }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt" label="创建时间" min-width="160" />
                <el-table-column prop="user_address" label="收货地址" min-width="300" />
                <el-table-column prop="user_tel" label="联系电话" min-width="120" />
                <el-table-column label="操作" min-width="260" align="center">
                    <template slot-scope="scope">
                        <div style="display: flex; justify-content: center; gap: 8px">
                            <el-button v-if="scope.row.user_address || scope.row.user_tel || scope.row.user_phone" type="info" size="mini" plain icon="el-icon-document-copy" @click="copyOrderInfo(scope.row)"> 复制 </el-button>
                            <div v-if="scope.row.status === '申请取消'">
                                <el-button type="success" size="mini" @click="applyOrderStatus(scope.row, '订单取消')"> 确认退货 </el-button>
                                <el-button type="danger" size="mini" @click="applyOrderStatus(scope.row, '待收货')"> 拒绝 </el-button>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 订单明细对话框 -->
            <el-dialog title="订单明细" :visible.sync="dialogVisible" width="1000px" custom-class="order-detail-dialog">
                <div v-if="selectedOrder">
                    <el-table :data="selectedOrder.items" style="width: 100%" border>
                        <el-table-column prop="sku_no" label="货号" width="120" />
                        <el-table-column prop="sku_name" label="商品名称" />
                        <el-table-column prop="sku_spec" label="规格" width="180" />
                        <el-table-column prop="count" label="数量" width="80" align="center" />
                        <el-table-column prop="price" label="单价(¥)" width="100" align="right" />
                        <el-table-column prop="remark" label="营销策略" width="100" align="right" />
                        <el-table-column label="小计(¥)" width="100" align="right">
                            <template slot-scope="scope">
                                {{ (scope.row.amount != null ? scope.row.amount : scope.row.price * scope.row.count).toFixed(2) }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-dialog>
            <el-dialog title="填写物流信息" :visible.sync="logisticsDialogVisible" width="400px">
                <el-form :model="logisticsForm" label-width="90px">
                    <el-form-item label="快递公司">
                        <el-select v-model="logisticsForm.company" placeholder="请选择快递公司" style="width: 100%">
                            <el-option v-for="item in logisticsCompanies" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="快递单号">
                        <el-input v-model="logisticsForm.trackingNumber" placeholder="请输入快递单号" />
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="logisticsDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="confirmLogistics">确定</el-button>
                </span>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import { OrderList, OrderEdit } from '@/api/api.js'

export default {
    name: 'AdminOrders',
    data() {
        const now = new Date()
        const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
        return {
            orders: [],
            dateRange: [today, today],
            soundEnabled: true,
            pollTimer: null,
            lastOrderIds: [],
            audioEl: null,
            searchKeyword: '',
            statusFilter: '全部',
            selectedOrder: null,
            dialogVisible: false,
            logisticsDialogVisible: false,
            logisticsForm: {
                company: '',
                trackingNumber: '',
                orderId: null,
            },
            logisticsCompanies: [
                { label: '顺丰速运', value: '顺丰速运' },
                { label: '中通快递', value: '中通快递' },
                { label: '圆通速递', value: '圆通速递' },
                { label: '韵达快递', value: '韵达快递' },
                { label: '申通快递', value: '申通快递' },
                { label: '京东物流', value: '京东物流' },
                { label: '极兔快递', value: '极兔快递' },
                { label: '邮政快递包裹', value: '邮政快递包裹' },
            ],
        }
    },
    computed: {
        summary() {
            return {
                totalOrders: this.orders.length,
                totalAmount: this.orders.reduce((sum, order) => sum + order.totalAmount, 0),
                pendingOrders: this.orders.filter((order) => order.status === '待发货').length,
                paidOrders: this.orders.filter((order) => order.status === '待发货').length, // Assuming 'paid' maps to '待发货' in this context or is not used in template
                shippedOrders: this.orders.filter((order) => order.status === '待收货').length,
                completedOrders: this.orders.filter((order) => order.status === '订单完成').length,
                pendingRefunds: this.orders.filter((order) => order.refundStatus === 'requested').length,
            }
        },
    },
    created() {
        this.loadOrdersFromApi()
        this.startPolling()
    },
    mounted() {
        this.audioEl = new Audio('/notify.mp3')
        this.audioEl.preload = 'auto'
        this.audioEl.volume = 0.6
        const once = () => {
            if (this.audioEl) {
                this.audioEl.currentTime = 0
                this.audioEl
                    .play()
                    .then(() => {
                        this.audioEl.pause()
                        this.audioEl.currentTime = 0
                    })
                    .catch(() => {})
            }
            window.removeEventListener('click', once)
        }
        window.addEventListener('click', once, { once: true })
    },
    beforeDestroy() {
        this.stopPolling()
    },
    watch: {
        soundEnabled(val) {
            if (val && this.audioEl) {
                this.audioEl.currentTime = 0
                this.audioEl
                    .play()
                    .then(() => {
                        this.audioEl.pause()
                        this.audioEl.currentTime = 0
                    })
                    .catch(() => {})
            }
        },
    },
    methods: {
        handleDateChange() {
            // Logic to filter orders based on dateRange can be added here
            // For now, just reloading to trigger any potential filtering logic
            this.loadOrdersFromApi()
        },
        handleRowDblclick(row) {
            this.openOrderDetail(row)
        },
        openOrderDetail(row) {
            this.selectedOrder = row
            this.dialogVisible = true
        },
        async loadOrdersFromApi() {
            try {
                let params = {}
                if (this.dateRange && this.dateRange.length === 2) {
                    params.start_date = this.dateRange[0]
                    params.end_date = this.dateRange[1]
                }

                // 添加搜索关键字参数（允许为空字符串）
                params.keyword = (this.searchKeyword || '').trim()
                // 添加状态筛选参数，默认传“全部”
                params.status = this.statusFilter || '全部'

                const res = await OrderList(params)

                if (res && res.data) {
                    const list = Array.isArray(res.data) ? res.data : []
                    const mapped = list.map((o) => {
                        let items = []
                        if (o.detail) {
                            try {
                                const parsed = typeof o.detail === 'string' ? JSON.parse(o.detail) : o.detail
                                if (Array.isArray(parsed)) {
                                    items = parsed
                                }
                            } catch (e) {
                                console.error('parse order detail error', e)
                            }
                        }
                        return {
                            ...o,
                            userName: o.user_account,
                            items,
                            totalAmount: o.pay_amount != null ? o.pay_amount : o.original_amount || 0,
                            trackingNumber: o.express_no || o.order_no || '',
                            express_company: o.express_company || '',
                            express_no: o.express_no || '',
                            createdAt: o.order_time || o.create_time || '',
                            status: o.order_status || o.status || '',
                            refundStatus: o.refundStatus || 'none',
                        }
                    })
                    this.compareAndNotify(mapped)
                    return
                }
            } catch (e) {
                console.error(e)
            }
            // Fallback or remove fallback if API is mandatory
            // const local = getOrders()
            // this.compareAndNotify(local)
        },
        startPolling() {
            if (this.pollTimer) return
            this.pollTimer = setInterval(() => {
                this.loadOrdersFromApi()
            }, 300000)
        },
        stopPolling() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
        },
        compareAndNotify(nextList) {
            const prev = new Set(this.lastOrderIds)
            const nextIds = nextList.map((o) => o.id)
            const hasNew = nextIds.some((id) => !prev.has(id))
            this.orders = nextList
            this.lastOrderIds = nextIds
            if (hasNew && this.soundEnabled) {
                this.playNewOrderSound()
            }
        },
        getAvailableStatusActions(row) {
            const current = row.status
            if (current === '待发货') {
                return [
                    { label: '待收货', value: '待收货' },
                    { label: '订单取消', value: '订单取消' },
                ]
            }
            if (current === '待收货') {
                return [
                    { label: '订单取消', value: '订单取消' },
                    { label: '订单完成', value: '订单完成' },
                ]
            }
            if (current === '申请取消') {
                return [
                    { label: '待收货', value: '待收货' },
                    { label: '订单取消', value: '订单取消' },
                ]
            }
            return []
        },
        async changeStatus(row, targetStatus) {
            const current = row.status
            if (current === '待发货') {
                if (targetStatus === '待收货') {
                    await this.markToReceivingWithLogistics(row)
                } else if (targetStatus === '订单取消') {
                    this.applyOrderStatus(row, '订单取消')
                }
                return
            }
            if (current === '待收货') {
                if (targetStatus === '订单取消' || targetStatus === '订单完成') {
                    this.applyOrderStatus(row, targetStatus)
                }
                return
            }
            if (current === '申请取消') {
                if (targetStatus === '待收货' || targetStatus === '订单取消') {
                    this.applyOrderStatus(row, targetStatus)
                }
            }
        },
        applyOrderStatus(row, status, extra = {}) {
            const updated = { ...row, status, ...extra }
            this.orders = this.orders.map((o) => (o.id === row.id ? updated : o))
            const orderNo = updated.order_no || updated.orderNo || ''
            if (!orderNo) return
            const payload = {
                order_no: orderNo,
                order_status: status,
                express_company: updated.expressCompany || updated.express_company || '',
                express_no: updated.trackingNumber || updated.express_no || '',
            }
            OrderEdit(payload)
                .then((res) => {
                    if (!(res && (res.code === 200 || res.status === 200 || res.success))) {
                        this.$message.error(res && res.msg ? res.msg : '保存订单信息失败')
                    }
                })
                .catch(() => {
                    this.$message.error('保存订单信息失败')
                })
        },
        async markToReceivingWithLogistics(row) {
            this.logisticsForm = {
                company: '',
                trackingNumber: '',
                orderId: row.id,
            }
            this.logisticsDialogVisible = true
        },
        confirmLogistics() {
            const company = (this.logisticsForm.company || '').trim()
            const tracking = (this.logisticsForm.trackingNumber || '').trim()
            if (!company) {
                this.$message.error('请选择快递公司')
                return
            }
            if (!tracking) {
                this.$message.error('请输入快递单号')
                return
            }
            const row = this.orders.find((o) => o.id === this.logisticsForm.orderId)
            if (!row) {
                this.logisticsDialogVisible = false
                return
            }
            this.applyOrderStatus(row, '待收货', {
                trackingNumber: tracking,
                express_no: tracking,
                expressCompany: company,
                express_company: company,
            })
            this.logisticsDialogVisible = false
            this.$message.success('已更新为待收货并保存快递信息')
        },
        playNewOrderSound() {
            try {
                if (!this.audioEl) {
                    this.audioEl = new Audio('/notify.mp3')
                    this.audioEl.preload = 'auto'
                    this.audioEl.volume = 0.6
                }
                this.audioEl.currentTime = 0
                this.audioEl.play().catch(() => {})
            } catch (e) {
                void e
            }
        },
        remove(id) {
            this.$confirm('确认删除该订单吗？', '提示', { type: 'warning' })
                .then(() => {
                    this.orders = this.orders.filter((o) => o.id !== id)
                })
                .catch(() => {})
        },
        copyOrderInfo(row) {
            const text = `${row.user_address || ''} ${row.user_tel || row.user_phone || ''}`.trim()
            if (!text) {
                this.$message.warning('没有可复制的信息')
                return
            }

            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard
                    .writeText(text)
                    .then(() => {
                        this.$message.success('已复制到剪切板')
                    })
                    .catch(() => {
                        this.fallbackCopy(text)
                    })
            } else {
                this.fallbackCopy(text)
            }
        },
        fallbackCopy(text) {
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            textArea.style.top = '-999999px'
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            try {
                document.execCommand('copy')
                this.$message.success('已复制到剪切板')
            } catch (err) {
                this.$message.error('无法复制信息')
            }
            document.body.removeChild(textArea)
        },
    },
}
</script>

<style>
.order-detail-dialog .el-dialog {
    height: 70vh;
    display: flex;
    flex-direction: column;
}

.order-detail-dialog .el-dialog__body {
    flex: 1;
    overflow-y: auto;
}
</style>
